import React from 'react'

const Contact = ({ icon, title, value, action }) => {
    return (
        <a href={action} target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 duration-400 min-w-[130px] md:min-w-[200px] mb-4 md:mb-0 flex flex-1 flex-col text-lg justify-center items-center text-white hover:scale-110'>
            <div className='p-3 flex-1 text-3xl rounded-full bg-zinc-950 mb-3'>
                {icon}
            </div>
            <div className='flex-1'>
                {title}
            </div>
            <div className='flex-1 text-zinc-400 text-sm md:text-lg'>
                {value}
            </div>
        </a>
    )
}

export default Contact